<template>
  <div>
    ตารางการโอนถ่ายขยะ Transfer Waste All {{ nowDate }}
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-left">รถเก็บขน</th>
            <th class="text-left">70-7580</th>
            <th class="text-left">10ล้อ</th>
            <th class="text-left">10ล้อ</th>
            <th class="text-left">โกดัง</th>
            <th class="text-left">เทศบาล</th>
            <th class="text-left">อื่นๆ</th>
            <th class="text-left">ขยะรวม</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in desserts" :key="item.name">
            <td>{{ item.name }}</td>
            <td>{{ item.calories }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>
<script>
import moment from "moment";
export default {
  name: "comTransferWasteAll",
  props: {
    nowDate: Date,
  },
  data() {
    return {
      desserts: [
        {
          name: "Frozen Yogurt",
          calories: 159,
        },
        {
          name: "Ice cream sandwich",
          calories: 237,
        },
        {
          name: "Eclair",
          calories: 262,
        },
        {
          name: "Cupcake",
          calories: 305,
        },
        {
          name: "Gingerbread",
          calories: 356,
        },
        {
          name: "Jelly bean",
          calories: 375,
        },
        {
          name: "Lollipop",
          calories: 392,
        },
        {
          name: "Honeycomb",
          calories: 408,
        },
        {
          name: "Donut",
          calories: 452,
        },
        {
          name: "KitKat",
          calories: 518,
        },
      ],
    };
  },
  watch: {},
  computed: {
    // this.search_TransferWasteAll(this.nowDate);
  },
  methods: {
    search_TransferWasteAll(item) {
      let NowDate = moment(item).format("YYYY-MM-DD");
      // console.log(NowDate);
      this.$token_api
        .post('/search_TransferWasteAll',{T:NowDate})
        .then((res) => {
          // console.log(res.data.data);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  updated() {
    //this.search_TransferWasteAll(this.nowDate);
  },
};
</script>